export function generatePyramidRowSizes(total: number): number[] {
  // OCNC preferred formation for 15 riders.
  if (total === 15) {
    return [1, 2, 4, 4, 4];
  }

  const rowSizes: number[] = [];
  let left = total;
  let rowIndex = 0;

  while (left > 0) {
    let size = rowIndex < 4 ? rowIndex + 1 : 5;
    if (size > left) {
      size = left;
    }
    rowSizes.push(size);
    left -= size;
    rowIndex++;
  }

  return rowSizes;
}

export function generateBenchRowSizes(total: number): number[] {
  if (total <= 0) return [];
  if (total <= 5) return [total];

  return [5, total - 5];
}

export function chunkByRowSizes<T>(items: T[], sizes: number[]): T[][] {
  const chunks: T[][] = [];
  let startIndex = 0;

  for (const size of sizes) {
    chunks.push(items.slice(startIndex, startIndex + size));
    startIndex += size;
  }

  return chunks;
}
